// ============================================================
// Mock data — status labels (compartido por todas las listas)
//
// Flujo real de Impact Hub. El orden del objeto define el orden de
// las columnas del tablero (canva).
// ============================================================
export const STATUS_LABELS = {
  prenotice:   { label: 'Anuncio previo', sem: 'sem-neutral' },
  spotted:     { label: 'Avistada',       sem: 'sem-info'    },
  analysis:    { label: 'Análisis',       sem: 'sem-violet'  },
  preparation: { label: 'Preparación',    sem: 'sem-warning' },
  submitted:   { label: 'Presentada',     sem: 'sem-neutral' },
  solvency:    { label: 'Solvencia',      sem: 'sem-info'    },
  won:         { label: 'Adjudicada',     sem: 'sem-success' },
  lost:        { label: 'Perdida',        sem: 'sem-danger'  },
  discarded:   { label: 'Descartada',     sem: 'sem-danger'  },
};

// Orden de flujo (para tablero y selectores).
export const STATUS_FLOW = [
  'prenotice', 'spotted', 'analysis', 'preparation',
  'submitted', 'solvency', 'won', 'lost', 'discarded',
];

// Etiqueta del estado "IA en curso" (analysis_status === 'processing').
// Es distinto del estado de flujo `analysis` (ficha ya creada, pendiente de
// decisión humana). Se muestra con icono animado y color de marca.
export const AI_ANALYZING = { label: 'Analizando con Lizzi', sem: 'sem-violet' };
